var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-template"},[_vm._v("서울시 송파구 충민로 66 테크노관 10층 T-10017 전화. 02-2157-1114 "),_c('br'),_vm._v(" 송파구시설관리공단 대표자 : 황대성 고유번호 : 215-82-06107"),_c('br'),_vm._v(" COPYRIGHT(C)2012 SONGPAGU FACILITIES MANAGEMENT CORPORATION ALL RIGHT RESERVED. ")])
}]

export { render, staticRenderFns }